/** Shared section header typography for estimate split panels */
export const estimateSectionHeaderProps = {
  fontSize: "0.8rem",
  color: "gray.600",
  fontFamily: "'Nunito','Inter', sans-serif",
  fontWeight: "800",
  textTransform: "uppercase" as const,
  letterSpacing: "0.02em",
};

/** Shared label typography for delivery option/configuration fields */
export const estimateFieldLabelProps = {
  fontSize: "0.75rem",
  color: "gray.600",
  fontFamily: "'Nunito','Inter', sans-serif",
  fontWeight: "600",
  whiteSpace: "nowrap" as const,
};
